
export const COGNITO_INFO = 'COGNITO_INFO'
export const EXPIRE_REDIRECT_URL = 'https://rasa.io/logout'
export const USER_LOGIN = 'USER_LOGIN'
export const UPDATE_LOGIN_FIELD = 'UPDATE_LOGIN_FIELD'



// WEBPACK FOOTER //
// ./src/pages/oauth-login/constants.ts